import React from "react";
import "./ui.scss";

export type TabItem = { id: string; label: string };

export const Tabs: React.FC<{ tabs: TabItem[]; activeId: string; onChange: (id: string) => void }>
= ({ tabs, activeId, onChange }) => {
  const onKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
    const idx = tabs.findIndex(t => t.id === activeId);
    if (e.key === "ArrowRight") onChange(tabs[(idx + 1) % tabs.length].id);
    if (e.key === "ArrowLeft") onChange(tabs[(idx - 1 + tabs.length) % tabs.length].id);
  };
  return (
    <div className="tabs">
      <div className="tablist" role="tablist" onKeyDown={onKeyDown}>
        {tabs.map(t => (
          <button
            key={t.id}
            role="tab"
            aria-selected={t.id === activeId}
            className="tab"
            onClick={() => onChange(t.id)}
          >{t.label}</button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;


